/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmailNotificationV1Dto } from './EmailNotificationV1Dto';
import type { ReminderSettingsV1Dto } from './ReminderSettingsV1Dto';
import type { TemplatePlaceholdersV1Dto } from './TemplatePlaceholdersV1Dto';
export type InitiateSignaturePayloadV1Dto = {
  /**
   * The audit trail locale
   */
  audit_trail_locale?: InitiateSignaturePayloadV1Dto.audit_trail_locale | null;
  /**
   * The custom experience id
   */
  custom_experience_id?: string | null;
  /**
   * The delivery mode
   */
  delivery_mode: InitiateSignaturePayloadV1Dto.delivery_mode;
  /**
   * Signature email notification settings
   */
  email_notification?: EmailNotificationV1Dto | null;
  /**
   * Signature expiration date
   */
  expiration_date?: string | null;
  /**
   * Store a custom id that will be added to webhooks & appended to redirect urls.
   */
  external_id?: string | null;
  /**
   * The labels of the signature
   */
  labels?: Array<string>;
  /**
   * The name of the signature request
   */
  name: string;
  /**
   * When enabled, Approvers are requested to approve sequentially. Each Approver will be invited to approve only once the previous one has completed their approval.
   */
  ordered_approvers?: boolean;
  /**
   * When enabled, Signers are requested to sign sequentially. Each Signer will be invited to sign only once the previous one has completed their signature.
   */
  ordered_signers: boolean;
  /**
   * Enable automatic reminders for pending signers.
   */
  reminder_settings?: ReminderSettingsV1Dto | null;
  /**
   * When enabled, Signers can decline the signature request.
   */
  signers_allowed_to_decline?: boolean;
  /**
   * Create a signature request from an existing template.
   */
  template_id?: string;
  /**
   * When creating a signature request from a template, all substituting data for placeholders defined in the given template.
   */
  template_placeholders?: TemplatePlaceholdersV1Dto | null;
  /**
   * Time zone of the dates and times displayed in emails, the Signature Request expiration date, and the PDF Audit Trail. Format: tz database. Default is set to Europe/Paris.
   */
  timezone?: string;
  /**
   * Scope the signature request to a specific workspace. If template_id is filled and Template is already linked to a Workspace, keep this field to null ; the created Signature Request will be scoped to Template's Workspace.
   */
  workspace_id?: string;
};
export namespace InitiateSignaturePayloadV1Dto {
  /**
   * The audit trail locale
   */
  export enum audit_trail_locale {
    DE = 'de',
    EN = 'en',
    ES = 'es',
    FR = 'fr',
    IT = 'it',
    PT = 'pt',
  }
  /**
   * The delivery mode
   */
  export enum delivery_mode {
    EMAIL = 'email',
    NONE = 'none',
  }
}
